"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const InstagramLikeIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.575 13.938a1 1 0 01-1.305 0l-.43-.37C2.998 10.256.461 8.071.461 5.396.461 3.211 2.263 1.5 4.565 1.5c1.298 0 2.544.574 3.357 1.477.814-.903 2.06-1.477 3.358-1.477 2.302 0 4.103 1.71 4.103 3.896 0 2.675-2.536 4.86-6.379 8.172l-.43.37z",
    clipRule: "evenodd"
  })))
});
InstagramLikeIcon.displayName = 'InstagramLikeIcon';
var _default = exports.default = InstagramLikeIcon;